import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { create } from 'kts-scaffold-framework/utils/form';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import Credentials from './UI.Credentials';
import moment from 'moment';
import {
    Form,
    Input,
    Select,
    Radio,
    Button,
    Row,
    Col,
    DatePicker,
    Upload,
    Icon,
    Modal
} from 'antd';

const css = require('./index.scss');
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const TextArea = Input.TextArea;
const Option = Select.Option;

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    type?: number; // 0 => 新增 1 => 查看/修
    id?: string;
}

/** 绑定全局数据到props */
@create()
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }

    componentWillUnmount () {
        ModulesAction.changeEditEndValue('');
        ModulesAction.changeEditStartValue('');
    }
    
    render() {
        const getFieldDecorator = this.props.form.getFieldDecorator;
        const type = this.props.type && this.props.type;
        const industryList = this.modulesState.industryList;
        const qualificationInfo = this.modulesState.qualificationInfo;
        const dateFormate = 'YYYY-MM-DD';
        return (
            <div className={css['editQualification']}>
                <Form>
                    <Row type="flex" justify="space-between">
                        <Col span={24}>
                            <FormItem label="资质编号">
                                {
                                    getFieldDecorator('code', {
                                        rules: [
                                            {required: true, message: '请输入资质编号'}
                                        ],
                                        initialValue: type ? qualificationInfo.code : undefined
                                    })
                                    (<Input/>)
                                }
                            </FormItem>
                        </Col>
                        <Col span={24}>
                            <FormItem label="资质名称">
                                { 
                                    getFieldDecorator('name', {
                                        rules: [
                                            {required: true, message: '请输入资质名称'}
                                        ],
                                        initialValue: type ? qualificationInfo.name : undefined
                                    })
                                    (<Input/>)
                                }
                            </FormItem>
                        </Col>
                        <Col span={24}>
                            <FormItem label="所属行业">
                                { 
                                    getFieldDecorator('industry', {
                                        rules: [
                                            {required: true, message: '请选择所属行业'}
                                        ],
                                        initialValue: type ? qualificationInfo.industry : undefined
                                    })
                                    (
                                        <Select
                                            showSearch={true}
                                        >
                                            {
                                                industryList.map(el => {
                                                    return (<Option key={el.name}>{el.name}</Option>);
                                                })
                                            }
                                        </Select>
                                    )
                                }
                            </FormItem>
                        </Col>
                        <Col span={24}>
                            <FormItem label='有效期'>
                                <Col span={11}>
                                    <FormItem>
                                        { 
                                            getFieldDecorator('startTime', {
                                                initialValue: type ? (qualificationInfo.startTime ? moment(moment(qualificationInfo.startTime).format(dateFormate), dateFormate) : undefined) : undefined
                                            })
                                            (<DatePicker
                                                style={{ width: '100%' }} 
                                                disabledDate={this.disabledStartDate}
                                                onChange={ModulesAction.changeEditStartValue}
                                            />)
                                        }
                                    </FormItem>
                                </Col>
                                <Col span={2}>
                                    <span style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}>
                                        -
                                    </span>
                                </Col>
                                <Col span={11}>
                                    <FormItem>
                                        { 
                                            getFieldDecorator('endTime', {
                                                initialValue: type ? (qualificationInfo.endTime ? moment(moment(qualificationInfo.endTime).format(dateFormate), dateFormate) : undefined) : undefined
                                            })
                                            (<DatePicker
                                                style={{ width: '100%' }}
                                                disabledDate={this.disabledEndDate}
                                                onChange={ModulesAction.changeEditEndValue}
                                            />)
                                        }
                                    </FormItem>
                                </Col>
                            </FormItem>
                        </Col>
                        <Col>
                            <FormItem label="上传证件">
                                {
                                    getFieldDecorator('imageLogId',{
                                        initialValue: type ? qualificationInfo.imageUrl : undefined
                                    })
                                    (<Credentials type={this.props.type}/>)
                                }
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
                <div className={css['editQualification-hander']}>
                    {
                        type ?
                        (
                            <Button
                                className={`${css['dispatch-common-green']} ${css['dispatch-common-height']}`}
                                type="primary"
                                onClick={this.updateQualification}
                            >修改
                            </Button>
                        ) : 
                        (
                            <Button
                                className={`${css['dispatch-common-green']} ${css['dispatch-common-height']}`}
                                type="primary"
                                onClick={this.createQualification}
                            >新增
                            </Button>
                        )
                    }
                    <Button
                        className={`${css['dispatch-common-sliver']} ${css['dispatch-common-height']}`}
                        onClick={this.hideAside}
                    >关闭
                    </Button>
                </div>
            </div>
        );
    }

    private createQualification = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                ModulesAction.createQualification(values)
                .then(res => {
                    this.props.form.resetFields();
                    ModulesAction.changeSnapImg('');
                    ModulesAction.changeEditEndValue('');
                    ModulesAction.changeEditStartValue('');
                });
            }
        });
    }

    private hideAside = () => {
        ModulesAction.hideAside();
    }

    private updateQualification = () => {
        this.props.form.validateFields((err, value) => {
            if (!err) {
                const option = Object.assign({}, value, {qualificationId: this.props.id});
                ModulesAction.updateQualification(option);
            }
        });
    }

    private disabledStartDate = (startValue) => {
        const endValue = this.modulesState.editEndValue;
        if (!startValue || !endValue) {
          return false;
        }
        return startValue.valueOf() > endValue.valueOf();
    }
    
    private disabledEndDate = (endValue) => {
        const startValue = this.modulesState.editStartValue;
        if (!endValue || !startValue) {
          return false;
        }
        return endValue.valueOf() <= startValue.valueOf();
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/CompanyInfo/Qualification/UI.Edit.tsx